import React from 'react';

import { Translate } from 'core/translate';
import type { NearbyTerminal as NearbyTerminalsType } from 'ProviderInformation-Types';

type Props = {
  className?: string;
} & NearbyTerminalsType;

function NearbyTerminals({ className, name, time, transportation }: Props) {
  let data;
  let translateId: string;
  if (time < 60) {
    translateId = 'Traveler_Common.Terminal_Minutes';
    data = {
      nearby_terminal_time_required: time,
      nearby_terminal_transportation: transportation,
      nearby_terminal_terminal: name,
    };
  } else if (time % 60 === 0) {
    translateId = 'Traveler_Common.Terminal_Hours';
    data = {
      nearby_terminal_time_required_hours: Math.floor(time / 60),
      nearby_terminal_transportation: transportation,
      nearby_terminal_terminal: name,
    };
  } else {
    translateId = 'Traveler_Common.Terminal_Hours_Minutes';
    data = {
      nearby_terminal_time_required_hours: Math.floor(time / 60),
      nearby_terminal_time_required_minutes: time % 60,
      nearby_terminal_transportation: transportation,
      nearby_terminal_terminal: name,
    };
  }

  return (
    <div className={className} data-testid="nearbyTerminals-wrapper">
      <Translate id={translateId} data={data} />
    </div>
  );
}

export default NearbyTerminals;
